import {invertedString} from './englishHebrewKeyMap';

const stripPunctuation = (s) => s.replace(/[^\p{L}\p{N}\s]/gu, '');

export const localSearch = (array, value, searchColumns) => {
    const absoluteValue = invertedString(value);

    const searchAllColumns = !Array.isArray(searchColumns) || searchColumns.length === 0;

    const filteredList = array.filter((item) => {
        if(!item) return false;

        const keysToSearchIn = searchAllColumns ? Object.keys(item) : searchColumns;

        return keysToSearchIn.some((key) => {
            const columnValue = String(item[key]).toLowerCase();
            const strippedColumnValue = stripPunctuation(columnValue);
            const searchTerms = value.toLowerCase().split(' ');
            const absoluteSearchTerms = absoluteValue.toLowerCase().split(' ');

            const matchesIn = (cv) => (
                searchTerms.every((term) => cv.includes(term)) ||
                absoluteSearchTerms.every((term) => cv.includes(term))
            );

            return matchesIn(columnValue) || matchesIn(strippedColumnValue);
        });
    });

    return filteredList;
};
